

























import Vue from 'vue'
import GuestPerksModal from '~/components/car/classifieds/form/GuestPerksModal.vue'
import { mapDeps } from '~/plugins/dependency-container/utils'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'

export default Vue.extend({
  components: { GuestPerksModal },
  data() {
    return {
      showGuestPerksModal: false
    }
  },
  computed: {
    ...mapDeps({ legacyUrlService: LegacyUrlService }),
    loginUrl(): string {
      return this.legacyUrlService.getUserLoginUrl()
    },
    registerUrl(): string {
      return this.legacyUrlService.getRegisterUrl()
    }
  }
})
